
import { ColDef, ColumnApi, GridApi, ICellRendererParams, ValueGetterParams } from "ag-grid-community";
import _, { set } from 'lodash';
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PullToRefresh from "react-simple-pull-to-refresh";
import { LoadNewOrganizations } from "../../actions";
import { setHeaderCount, setHeaderTitle, setRefreshHandler, } from "../../helpers/header.helper";
import setToast from "../../helpers/toaster.helper";
import { AddNumberIcon, DisableIcon, DownloadedIcon, EditIcon, MultiSelectCrossIcon, ReHostIcon, SettingsIcon, UploadFileIconBlue } from "../../icon";
import { NewOrganization } from "../../models/organization.model";
import { PhoneNumberModel, PhoneNumberStatus, ProviderModel, mapToPhoneNumber, PhoneNumbergroup, maptoPhoneNumberGroups, } from "../../models/phone-number.model";
import { PlanType } from "../../models/plans.model";
import { RechargeStatus } from "../../models/transaction-history.model";
import { PhoneNumberService } from "../../services/PhonenumberService";
import { UtilityService } from "../../services/UtilityService";
import { AppRoutes } from '../routes/route.path';
import ConfirmDialog from "../shared/confirm-dialog.component";
import { ActionLabels, GridStatusLabelVariant, PhoneNumberStatusLabels, ToasterTexts, appNote, buttonLabels, emptyLabels, pageTitles, } from "../shared/constants";
import FilterComponent from "../shared/filters/filter.component";
import { CustomFilterCategory } from "../shared/filters/filter.model";
import GridComponent from "../shared/grid";
import { ActionsRenderer } from '../shared/grid/actionsRenderer';
import { HeaderTemplate, dateComparator } from "../shared/grid/grid.services";
import { StatusRenderer } from "../shared/grid/statusRenderer";
import PageHeaderComponent from "../shared/page-header.component";
import PhoneSubscriberDetailsComponent from "../shared/phone-subscriber-details.component";
import SubpageHeaderComponent from "../shared/subpage-header.component";
import { ToasterType } from "../shared/toaster/toaster.model";
import { UserService } from "../../services/UserService";
import * as selector from "../../selectors/selectors";
import { useDispatch } from "react-redux";
import { updateNewSubscriptionOrganizationsphoneNumbers, updateNewSubscriptionPhonenumberSelectedOrgIDs, updateOrganizationPhoneNumberGroups } from "../../reducers/reducer";
import EditPhoneNumber from "../phone-numbers/edit-phone-number.component";
import PhoneNumberSettings from "../phone-numbers/settings.component";
import { exportToExcel } from "../../helpers/ExportToExcel";
import moment from "moment";
import PhoneNumberGroups from "../PhoneNumberGroup";
import { PhoneNumberGroupService } from "../../services/PhoneNumberGroupsServices";
import { Popover } from "@mui/material";



const PhoneNumbersComponent = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const Providers: ProviderModel[] = useSelector(selector.providers)
    const IsTeamsApp: boolean = useSelector(selector.isTeamsApp)
    const NewSubscriptionPhonenumberSelectedOrgIDs: string[] = useSelector(selector.NewSubscriptionPhonenumberSelectedOrgIDs)
    const NewSubscriptionOrganizationsphoneNumbers: PhoneNumberModel[] = useSelector(selector.NewSubscriptionOrganizationsphoneNumbers)
    const NewOrganizations: NewOrganization[] = useSelector(selector.newOrganizations)
    const IsDarkMode: boolean = useSelector(selector.isDarkMode)
    const OrganizationPhoneNumberGroups = useSelector(selector.OrganzationPhoneNumberGroups);



    const [gridApi, setGridApi] = useState<GridApi>(null)
    const [columnApi, setColumnApi] = useState<ColumnApi>(null)
    const [PhoneNumbers, setPhoneNumbers] = useState<PhoneNumberModel[]>([]);
    const [IsLoading, setIsLoading] = useState<boolean>(false)
    const [IsDeleted, setIsDeleted] = useState<boolean>(false)
    const [ButtonName, setButtonName] = useState<string>("")
    const [Text, setText] = useState<string>("")
    const [Show, setShow] = useState<boolean>(false)
    const [editPhoneNumber, setEditPhoneNumber] = useState<boolean>(false)
    const [ShowSettings, setShowSettings] = useState<boolean>(false)
    const [MobileMenu, setMobileMenu] = useState<boolean>(false)
    const [ViewDetails, setViewDetails] = useState<boolean>(false)
    const [PhoneNumberName, setPhoneNumberName] = useState<string>("")
    const [SelectedPhoneNumberId, setSelectedPhoneNumberId] = useState<string>("")
    const [anchorEl, setAnchorEl] = useState<Element | null>();
    const [ShowFilterOptions, setShowFilterOptions] = useState<boolean>(false);
    const [filterOptions, setFilterOptions] = useState<CustomFilterCategory[]>([]);
    const [selectedFilterTypes, setSelectedFilterTypes] = useState<string[]>([]);
    const [searchValue, setSearchValue] = useState<any>();
    const [selectedOrgIds, setSelectedOrgIds] = useState<string[]>([]);
    const [ShowMultiActionButtons, setShowMultiActionButtons] = useState<boolean>(false)
    const [gridLoading, setGridLoading] = useState<boolean>(false);
    const location = useLocation();

    useEffect(() => {
        const state = location.state as any;
        const id = state?.OrganizationID;
        const number = getOrgName(id);

        if (!!gridApi && !!number) {
            setSelectedOrgIds([id])
            setPhoneNumbers([])
            dispatch(updateNewSubscriptionPhonenumberSelectedOrgIDs([id]))
            // gridApi.setQuickFilter(number)
        }
        else {
            setSelectedOrgIds(NewSubscriptionPhonenumberSelectedOrgIDs)
            setPhoneNumbers(NewSubscriptionOrganizationsphoneNumbers)
        }
    }, [gridApi, NewOrganizations])


    useEffect(() => {
        if (!!gridApi && gridLoading) {
            gridApi?.refreshCells({ force: true })
        }
    }, [gridLoading])

    const getPhoneNumbers = (ids) => {
        if ((PhoneNumbers.length === 0 || ids.length > 0) && !!gridApi) {
            gridApi.showLoadingOverlay();
        }
        PhoneNumberService.getGridByOrganizations(ids).then((res) => {
            if (res.status === 200) {
                setGridLoading(false)
                const data = res.data.map(mapToPhoneNumber)
                setPhoneNumbers(data);
                dispatch(updateNewSubscriptionOrganizationsphoneNumbers(data))
                dispatch(updateNewSubscriptionPhonenumberSelectedOrgIDs(ids))
                if (!!selectedOrgIds) {
                    setRefreshHandler(() => getPhoneNumbers(selectedOrgIds));
                }
            }
        }).catch((err) => {
            setGridLoading(false)
            setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER)
        })

        if ((PhoneNumberGroups.length === 0 || ids.length > 0) && !!gridApi) {
            gridApi.showLoadingOverlay();
        }
        PhoneNumberGroupService.getGridByOrganizations(ids).then((res => {
            dispatch(updateOrganizationPhoneNumberGroups(res.data.map(maptoPhoneNumberGroups)))
        })).catch()
    }
    useEffect(() => {
        if (NewOrganizations?.length === 0) {
            LoadNewOrganizations(dispatch);
        }
        setHeaderTitle(pageTitles.PHONENUMBERS);
    }, []);

    useEffect(() => {
        if (selectedOrgIds.length === 0) {
            setShowMultiActionButtons(false)
            setGridLoading(true)
            setRefreshHandler(() => getPhoneNumbers(selectedOrgIds));
        }
        else {
            setShowMultiActionButtons(true)
        }

    }, [selectedOrgIds])

    useEffect(() => {
        setHeaderTitle(pageTitles.PHONENUMBERS);
        setHeaderCount(PhoneNumbers?.length || 0)
        setRefreshHandler(gridRefresh)
        return setHeaderTitle
    }, [gridApi, columnApi])

    const resetFilters = () => {
        setFilterOptions([])
        setSelectedFilterTypes([])
        initialFilterOptions()
    }

    const gridRefresh = () => {
        resetFilters()
        if (!!columnApi) {
            columnApi?.resetColumnState()
        }
        if (!!gridApi) {
            gridApi?.refreshCells({ force: true })
        }
        gridApi?.deselectAll();
        dispatch(updateNewSubscriptionPhonenumberSelectedOrgIDs([]))
        dispatch(updateNewSubscriptionOrganizationsphoneNumbers([]));
    }

    const searchPhoneNumbers = (e) => {
        setSearchValue(e.target.value)
        gridApi?.setQuickFilter(e.target.value)
    }

    const onGridReady = (params) => {
        setGridApi(params.api)
        setColumnApi(params.columnApi)
    }

    const getPhoneNumber = (id: string) => {
        return UtilityService.maskPhoneNumberOnLength(id);
    }

    const clearSelection = () => {
        if (!!gridApi && !!PhoneNumbers.length)
            gridApi.deselectAll();

        if (!!selectedOrgIds.length) {
            setShowMultiActionButtons(false)
            setSelectedOrgIds([])

            setPhoneNumbers([]);
            dispatch(updateNewSubscriptionPhonenumberSelectedOrgIDs([]))
            dispatch(updateNewSubscriptionOrganizationsphoneNumbers([]));
        }
    }

    const OrgColoumnDefs: ColDef[] = [
        {
            field: "Name",
            headerName: "Name",
            cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
        },

        {
            field: "OrganizationID",
            headerName: "Organization",
            valueGetter: (params: ValueGetterParams) => {
                return getOrgName(params.data.OrganizationID)
            },
            cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
            hide: IsMobileDevice,

        },
        {
            field: "PhoneNumber",
            headerName: "Phone Number",
            valueFormatter: (params) => {
                return getPhoneNumber(params.data.PhoneNumber)
            },
            valueGetter: (params: ValueGetterParams) => {
                const raw = getPhoneNumber(params.data.PhoneNumber) || "";
                return ` ${raw}  ${raw.replace(/\D/g, "")} `;
            },
            cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
        },
        {
            field: "PhoneNumberGroup",
            headerName: "Line Group",
            valueGetter: (params: ValueGetterParams) => {
                const group = OrganizationPhoneNumberGroups.find(x => x.PhoneNumbers?.some(y => y.phoneNumberId === params.data.ID));
                return group ? group.GroupName : "---";
            },
            suppressSizeToFit: true,
            minWidth: IsMobileDevice ? null : 150,
            width: IsMobileDevice ? null : 150,
        },

        {
            field: "Status",
            headerName: "Status",
            valueGetter: (params: ValueGetterParams) => {
                return status(params.data.Status);
            },
            headerComponentParams: {
                template: selectedFilterTypes.includes("Status") ? `${HeaderTemplate.filterApplied(true)}` : ""
            },
            cellRendererSelector: (params: ICellRendererParams) => {
                if (params.data) {
                    const label = status(params.data.Status);
                    const variant = status(params.data.Status) === "Active" ? GridStatusLabelVariant.Active : status(params.data.Status) === "Inactive" ? GridStatusLabelVariant.Danger : status(params.data.Status) === "Payment due" ? GridStatusLabelVariant.Warning : GridStatusLabelVariant.Other;
                    const Status = {
                        component: StatusRenderer,
                        params: {
                            Variant: variant, Label: label, Id: params.data.ID
                        }
                    }
                    return Status
                }
                return undefined
            },
            suppressSizeToFit: true,
            minWidth: 140,
            width: 140,
            maxWidth: 140,
        },
        {
            field: "Users",
            headerName: "Users",
            valueGetter: (params: ValueGetterParams) => {
                return params.data.Users
            },
            cellRenderer: (params: ICellRendererParams) => {
                const State = { PhoneNumberID: params.data.ID, selectedOrgId: params.data.OrganizationID }
                return <Link to={AppRoutes.NEW_USERS} state={State} className="color-vigenary-light">{params.data.Users}</Link>
            },
            cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
        },
        {
            field: "CreatedDateTime",
            headerName: "Updated Date",
            valueGetter: (params: ValueGetterParams) => {
                return UtilityService.convertDateToDay(params.data.CreatedDateTime)
            },
            cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
            hide: IsMobileDevice,
            sort: 'desc',
            comparator: (valueA, valueB, nodeA, nodeB) => dateComparator(nodeA.data.CreatedDateTime, nodeB.data.CreatedDateTime),
        },
        {
            field: "Action",
            maxWidth: 40,
            headerName: "",
            pinned: "right",
            lockPinned: true,
            lockPosition: "right",
            cellClass: "ag-cell-actions-style",
            headerClass: "bg-color-secondary",
            cellRenderer: params =>
                <ActionsRenderer
                    MenuData={getMenuActions(params.data)}
                    {...params}
                />,
            resizable: false,
            sortable: false,
            hide: IsMobileDevice,
        },
    ]
    const status = (status: PhoneNumberStatus): string => {
        return PhoneNumberStatusLabels[PhoneNumberStatus[status]];
    }

    const getOrgName = (OrgId: string) => {
        if (!!NewOrganizations) {
            let x = NewOrganizations?.find((x) => x.ID === OrgId)?.Name || "";
            return x;
        }
    }

    const rehost = (phoneData?: PhoneNumberModel) => {
        if (!phoneData) {
            return;
        }
        navigate(AppRoutes.REHOST, { state: { ...phoneData, IsReHost: true }, replace: true })
    }

    const getMenuActions = (data: PhoneNumberModel) => {
        return [
            {
                Name: ActionLabels.REHOST,
                Icon: ReHostIcon,
                OnClick: () => { rehost(data) },
                Hide: !(((data as PhoneNumberModel)?.Status === PhoneNumberStatus.INACTIVE || ((data as PhoneNumberModel)?.Status === PhoneNumberStatus.ACTIVE && (data as PhoneNumberModel)?.IsDeleted))),
            },
            {
                Name: ActionLabels.EDIT,
                Icon: EditIcon,
                OnClick: () => {
                    setSelectedPhoneNumberId((data as PhoneNumberModel)?.ID);
                    setEditPhoneNumber(true);
                    setMobileMenu(false)
                },
            },
            {
                Name: ActionLabels.DISABLE,
                Icon: DisableIcon,
                OnClick: () => {
                    openConfirmDialog((data as PhoneNumberModel)?.ID, (data as PhoneNumberModel)?.IsDeleted)
                },
                Hide: ((data as PhoneNumberModel)?.Status === PhoneNumberStatus.INACTIVE),
            },
            {
                Name: ActionLabels.SETTINGS,
                Icon: SettingsIcon,
                OnClick: () => {
                    setShowSettings(true);
                    setSelectedPhoneNumberId((data as PhoneNumberModel)?.PhoneNumber);
                    setMobileMenu(false);
                },
                Hide: ((data as PhoneNumberModel)?.Status === PhoneNumberStatus.INACTIVE),
            },
            {
                Name: ActionLabels.VIEW_DETAILS,
                Icon: SettingsIcon,
                OnClick: () => {
                    viewDetails(data.Name, (data as PhoneNumberModel)?.ID)
                },
                Hide: !((data as PhoneNumberModel)?.Status !== PhoneNumberStatus.INACTIVE),
            },
        ]
    }

    const openConfirmDialog = (rowId: string, IsDeleted: boolean) => {
        let text = IsDeleted ? appNote.PHONENUMBER_ENABLE : appNote.PHONENUMBER_DISABLE;
        let btnName = IsDeleted ? "Enable" : "Disable";
        setShow(true);
        setSelectedPhoneNumberId(rowId);
        setText(text);
        setButtonName(btnName);
        setMobileMenu(false);
        setIsDeleted(IsDeleted);
        setIsLoading(false);
    }
    const viewDetails = (Name: string, ID: string) => {
        setViewDetails(true);
        setPhoneNumberName(Name);
        setSelectedPhoneNumberId(ID);
    };


    const handleRowClick = (row: PhoneNumberModel) => {
        if (IsMobileDevice) {
            setMobileMenu(true);
        }
    }

    const closeViewDeatils = () => {
        setViewDetails(false);
    }

    const closeEditPhoneNumber = (value?: boolean) => {
        setEditPhoneNumber(false);
        if (value && !!selectedOrgIds) {
            getPhoneNumbers(selectedOrgIds)
        }
    }

    const closeConfirmDialog = (isConfim: boolean) => {
        if (!!isConfim) {
            let Name = PhoneNumbers?.find((x: PhoneNumberModel) => x.ID === SelectedPhoneNumberId)?.Name || '';
            let subscriptionId = PhoneNumbers?.find((x: PhoneNumberModel) => x.ID === SelectedPhoneNumberId)?.Plans?.find(x => x.PlanType === PlanType.TIER && x.StatusType === RechargeStatus.ONGOING)?.SubscriptionID || '';
            setIsLoading(true)
            PhoneNumberService.unHostPhoneNumber(SelectedPhoneNumberId, subscriptionId).then(res => {
                setShow(false);
                setSelectedPhoneNumberId("");
                setIsLoading(false);
                setToast(!IsDeleted ? ToasterTexts.PHONENUMBER_DISABLE_SUCCESS.replace('<Name>', Name) : ToasterTexts.PHONENUMBER_ENABLE_SUCCESS.replace('<Name>', Name), ToasterType.SUCCESS)
                if (!!selectedOrgIds) {
                    getPhoneNumbers(selectedOrgIds);
                }

            });
        } else {
            setShow(false);
            setSelectedPhoneNumberId("");
            setIsLoading(false);;
        }
    };

    const closeSettings = () => {
        setShowSettings(false); setSelectedPhoneNumberId("");
    }

    const initialFilterOptions = () => {
        const filterData: CustomFilterCategory[] = [
            {
                Id: 2,
                Title: 'Status',
                IsSelectedAll: false,
                Options: _(PhoneNumbers)
                    .map((row) => ({
                        Key: "Status",
                        Id: row.ID,
                        Label: row.Status === PhoneNumberStatus.IN_PROGRESS ? PhoneNumberStatusLabels[PhoneNumberStatus[row.Status]] : row.Status === PhoneNumberStatus.PAYMENT_DUE ? PhoneNumberStatusLabels[PhoneNumberStatus[row.Status]] : row.Status === PhoneNumberStatus.ACTIVE ? PhoneNumberStatusLabels[PhoneNumberStatus[row.Status]] : PhoneNumberStatusLabels[PhoneNumberStatus[row.Status]],
                        Value: row.Status,
                        IsSelected: false
                    }))
                    .uniqBy('Label')
                    .value()
            }
        ]

        setFilterOptions(filterData)
    }

    useEffect(() => {
        initialFilterOptions()
        setHeaderCount(PhoneNumbers?.length || 0)
    }, [NewOrganizations, PhoneNumbers])

    const handleClickFilter = (event: React.MouseEvent<HTMLButtonElement>) => {

        if (IsMobileDevice) {
            setShowFilterOptions(true);
        }
        else {
            setAnchorEl(event.currentTarget)
        }
    }
    const handleCloseFilter = () => {
        setAnchorEl(null);
        setShowFilterOptions(false);
    }

    const handleApplyFilters = (filters) => {
        setFilterOptions(filters);
        const { result } = UtilityService.getFilterTypes(filters);
        setSelectedFilterTypes(result)
    };

    const downloadgriddataExcelFormat = () => {
        const data = PhoneNumbers.map(x => {
            return {
                ...x,
                Status: status(x.Status),
                CreatedDateTime: UtilityService.convertDateToDay(x.CreatedDateTime).toString(),
                OrganizationID: getOrgName(x.OrganizationID),
            }
        })

        const ExportReportHeaders = [
            { label: "Name", value: "Name" },
            { label: "Organization", value: "OrganizationID" },
            { label: "Phone Number", value: "PhoneNumber" },
            { label: "Status", value: "Status" },
            { label: "Users", value: "Users" },
            { label: "Updated Date", value: "CreatedDateTime" },
        ]

        exportToExcel(ExportReportHeaders, data, `FalkonSMS-PhoneNumbers-${moment(UtilityService.getPreferredTimeZoneTimeNow(), ["MM-DD-YYYY"]
        ).format("MM-DD-YYYY")}`, ToasterTexts.EXCEL_EXPORT_PHONENUMBERS_MESSAGE)
    };

    const pullToRefresh = () => new Promise((resolve) => setTimeout(resolve, 15)).then(() => { if (!!selectedOrgIds) return getPhoneNumbers(selectedOrgIds) })

    return (<>

        {
            editPhoneNumber && IsMobileDevice &&
            <SubpageHeaderComponent
                HeaderText={`${ShowSettings ? "PhoneNumber Settings" : editPhoneNumber ? "Edit PhoneNumber" : "Add PhoneNumber"}`}
                PreviousPage={ShowSettings ? closeSettings : closeEditPhoneNumber} />
        }
        {
            editPhoneNumber && IsMobileDevice ?
                <EditPhoneNumber
                    SelectedPhoneNumberId={SelectedPhoneNumberId}
                    HandleClose={closeEditPhoneNumber}
                    EditPhoneNumber={editPhoneNumber}
                    ProviderData={!!Providers && Providers.filter(x => x.Name !== "None")}
                    OrganizationData={NewOrganizations}
                /> :
                ShowSettings && IsMobileDevice ?
                    <PhoneNumberSettings
                        OnClose={closeSettings}
                        Settings={ShowSettings}
                        PhoneNumber={SelectedPhoneNumberId}
                    /> :
                    ViewDetails && IsMobileDevice ? (
                        <PhoneSubscriberDetailsComponent IsDarkMode={IsDarkMode}
                            PhoneNumberID={SelectedPhoneNumberId}
                            CloseViewDeatils={closeViewDeatils}
                            ViewDetails={ViewDetails}
                            IsMobileDevice={IsMobileDevice}
                            PhoneNumberName={PhoneNumberName} />)
                        : ShowFilterOptions && IsMobileDevice ? (
                            <FilterComponent
                                Filters={filterOptions}
                                HandleApplyFilters={handleApplyFilters}
                                OnClose={handleCloseFilter}
                            />
                        ) :
                            <PullToRefresh isPullable={IsMobileDevice} pullingContent='' onRefresh={pullToRefresh}>
                                <div className="d-flex flex-direction h-p-100 o-hidden justify-between">
                                    <PageHeaderComponent
                                        GridTitle={""}
                                        Count={PhoneNumbers.length}
                                        Actions={[
                                            {
                                                OnClick: () => navigate(AppRoutes.NEW_PHONE_NUMBER_IMPORT_REPORTS, {
                                                    state: { OrganizationID: selectedOrgIds.length === 1 ? selectedOrgIds[0] : "" }
                                                }),
                                                ButtonLabel: buttonLabels.VIEW_REPORTS,
                                                Variant: "secondary-btn",
                                                ClassName: "mr-2",
                                            },
                                            {
                                                OnClick: () => navigate(AppRoutes.NEW_PHONE_NUMBER_BULK_IMPORT),
                                                ButtonLabel: buttonLabels.BULK_IMPORT_USERS,
                                                Icon: UploadFileIconBlue,
                                                Variant: IsTeamsApp ? "disabled-btn" : "secondary-btn",
                                                ClassName: `${IsTeamsApp ? "mr-2 disable" : "mr-2"}`,
                                            },
                                            {
                                                OnClick: () => navigate(AppRoutes.NEW_ADD_PHONE_NUMBER),
                                                ButtonLabel: buttonLabels.ADD_PHONENUMBER,
                                                Icon: AddNumberIcon,
                                                Variant: IsTeamsApp ? "disabled-btn" : "primary-btn",
                                                ClassName: `${IsTeamsApp ? "mr-2 disable" : "mr-2"}`,
                                            },
                                            {
                                                OnClick: () => { downloadgriddataExcelFormat() },
                                                ButtonLabel: "",
                                                Icon: DownloadedIcon,
                                                Variant: "secondary-btn"
                                            }]}
                                        ShowMultiActionButtons={ShowMultiActionButtons}
                                        MultiActionButtons={[
                                            {
                                                Name: buttonLabels.APPLY,
                                                Variant: "primary",
                                                ClassName: `${IsTeamsApp ? "mr-2 disable" : "mr-2"}`,
                                                Hide: !UserService.hasSysAdminRole(),
                                                OnClick: () => { getPhoneNumbers(selectedOrgIds) }
                                            },
                                            {
                                                Name: ActionLabels.CLEAR_SELECTION,
                                                Variant: "text",
                                                ClassName: "p-0 mr-1 w-space",
                                                Icon: MultiSelectCrossIcon,
                                                Hide: false,
                                                OnClick: () => clearSelection()
                                            }
                                        ]}
                                        HandleFilter={handleClickFilter}
                                        ShowFilterIcon={true}
                                        IsFilterApplied={filterOptions.flatMap(x => x.Options.filter(x => x.IsSelected)).length}
                                        onSearch={searchPhoneNumbers}
                                        searchValue={searchValue}
                                        PlaceHolder={IsMobileDevice ? "Search..." : "Find a Phone Number..."}
                                        showAutoComplete={true}
                                        autoCompleteOptions={NewOrganizations?.filter(x => (x.Name !== null && !x.IsDeleted))}
                                        onChangeAutoComplete={(ids) => {
                                            setSelectedOrgIds(ids);
                                        }}
                                        autoCompleteValue={selectedOrgIds}
                                    />
                                    <GridComponent
                                        ColumnDefs={OrgColoumnDefs}
                                        RowData={PhoneNumbers}
                                        OnGridReady={onGridReady}
                                        IsPaginationEnabled={true}
                                        OnGridRowClick={handleRowClick}
                                        EmptyLabel={emptyLabels.PHONE_NUMBER}
                                        LockVisible={IsMobileDevice}
                                        filterOptions={filterOptions}
                                        IsFilterPresent={true}
                                        gridApi={gridApi}
                                    />
                                    {ViewDetails && (
                                        <PhoneSubscriberDetailsComponent IsDarkMode={IsDarkMode}
                                            CloseViewDeatils={closeViewDeatils}
                                            ViewDetails={ViewDetails}
                                            PhoneNumberID={SelectedPhoneNumberId}
                                            PhoneNumberName={PhoneNumberName}
                                            IsMobileDevice={IsMobileDevice} />)}
                                    {
                                        editPhoneNumber && !IsMobileDevice &&
                                        <EditPhoneNumber SelectedPhoneNumberId={SelectedPhoneNumberId}
                                            HandleClose={closeEditPhoneNumber}
                                            EditPhoneNumber={editPhoneNumber}
                                            ProviderData={!!Providers && Providers.filter(x => x.Name !== "None")}
                                            OrganizationData={NewOrganizations}
                                        />
                                    }
                                    {
                                        Show && <ConfirmDialog
                                            onClose={closeConfirmDialog}
                                            Show={Show}
                                            Text={Text}
                                            ButtonName={ButtonName}
                                            IsMobileDevice={IsMobileDevice}
                                            Loading={IsLoading}
                                        />
                                    }
                                    {
                                        ShowSettings && !IsMobileDevice &&
                                        <PhoneNumberSettings
                                            OnClose={closeSettings}
                                            Settings={ShowSettings}
                                            PhoneNumber={SelectedPhoneNumberId}
                                        />
                                    }
                                    {
                                        !IsMobileDevice && Boolean(anchorEl) &&
                                        <Popover
                                            open={Boolean(anchorEl)}
                                            anchorEl={anchorEl}
                                            onClose={handleCloseFilter}
                                            anchorOrigin={{
                                                vertical: 'top',
                                                horizontal: 'right',
                                            }}
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'left',
                                            }}
                                            classes={{ paper: `min-w-40 ${ShowFilterOptions ? "min-h-40" : ""}` }}
                                        // BackdropProps={{
                                        // 	invisible: true,
                                        // 	onClick: (event) => event.stopPropagation(),
                                        // }}
                                        >
                                            <FilterComponent
                                                Filters={filterOptions}
                                                HandleApplyFilters={handleApplyFilters}
                                                OnClose={handleCloseFilter}
                                            />
                                        </Popover>
                                    }

                                </div>
                            </PullToRefresh>}
    </>
    )
}

export default PhoneNumbersComponent;